import React, { useState, useEffect } from 'react';

const AddFormulaModal = ({
  newFormula,
  setNewFormula,
  onSubmit,
}) => {

  // Initialize price table with preset durations when component mounts
  useEffect(() => {
    if (newFormula.components_pricing_formula_prices.length === 0) {
      const presetDurations = [3, 7, 15];
      const initialPrices = presetDurations.map(duration => ({
        duration_days: duration,
        price: 0,
        deposit: 0
      }));
      setNewFormula({
        ...newFormula,
        components_pricing_formula_prices: initialPrices
      });
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formulaData = {
      ...newFormula,
    };

    try {
      await onSubmit(e, formulaData);
    } catch (error) {
      console.error('Error submitting formula:', error);
    }
  };

  return (
    <div className="modal" id="addFormulaModal" tabIndex="-1">
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <form onSubmit={handleSubmit}>
            <div className="modal-header">
              <h5 className="modal-title">Ajouter une formule</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div className="modal-body">
              {/* Formula Details */}
              <div className="mb-3">
                <label className="form-label">Nom</label>
                <input
                  type="text"
                  className="form-control"
                  value={newFormula.name}
                  onChange={(e) => setNewFormula({ ...newFormula, name: (e.target.value) })}
                  required
                />
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Quantité d'articles</label>
                    <input
                      type="number"
                      className="form-control"
                      value={newFormula.article_quantity}
                      onChange={(e) => setNewFormula({ ...newFormula, article_quantity: parseInt(e.target.value) })}
                      required
                      min="1"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Disponibilité</label>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={newFormula.available}
                        onChange={(e) => setNewFormula({ ...newFormula, available: e.target.checked })}
                      />
                      <label className="form-check-label">
                        {newFormula.available ? 'Disponible' : 'Indisponible'}
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              {/* Price Table */}
              <div className="mb-3">
                <label className="form-label">Tarifs par durée</label>
                <table className="table table-sm">
                  <thead>
                    <tr>
                      <th>Durée (jours)</th>
                      <th>Prix (€)</th>
                      <th>Caution (€)</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {newFormula.components_pricing_formula_prices.map((price, index) => (
                      <tr key={index}>
                        <td>
                          <input
                            type="number"
                            className="form-control form-control-sm"
                            value={price.duration_days}
                            onChange={(e) => {
                              const updatedPrices = [...newFormula.components_pricing_formula_prices];
                              updatedPrices[index].duration_days = parseInt(e.target.value);
                              setNewFormula({ ...newFormula, components_pricing_formula_prices: updatedPrices });
                            }}
                            min="1"
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            className="form-control form-control-sm"
                            value={price.price}
                            onChange={(e) => {
                              const updatedPrices = [...newFormula.components_pricing_formula_prices];
                              updatedPrices[index].price = parseFloat(e.target.value);
                              setNewFormula({ ...newFormula, components_pricing_formula_prices: updatedPrices });
                            }}
                            step="0.01"
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            className="form-control form-control-sm"
                            value={price.deposit}
                            onChange={(e) => {
                              const updatedPrices = [...newFormula.components_pricing_formula_prices];
                              updatedPrices[index].deposit = parseFloat(e.target.value);
                              setNewFormula({ ...newFormula, components_pricing_formula_prices: updatedPrices });
                            }}
                            step="0.01"
                          />
                        </td>
                        <td>
                          <button
                            type="button"
                            className="btn btn-sm btn-danger"
                            onClick={() => {
                              const updatedPrices = newFormula.components_pricing_formula_prices.filter((_, i) => i !== index);
                              setNewFormula({ ...newFormula, components_pricing_formula_prices: updatedPrices });
                            }}
                          >
                            X
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan="3">
                        <button
                          type="button"
                          className="btn btn-sm btn-secondary"
                          onClick={() => {
                            setNewFormula({
                              ...newFormula,
                              components_pricing_formula_prices: [
                                ...newFormula.components_pricing_formula_prices,
                                { duration: 0, price: 0 }
                              ]
                            });
                          }}
                        >
                          Ajouter un tarif
                        </button>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                Annuler
              </button>
              <button type="submit" className="btn btn-primary">
                Ajouter
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddFormulaModal;